import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import Message from './Message';
import RoundedBtn from './Common/RoundedBtn';
import { messagesData } from '../data/whatsappchat';
import { MdSearch, MdSend } from 'react-icons/md';
import { HiDotsVertical } from 'react-icons/hi';
import { BiHappy } from 'react-icons/bi';
import { AiOutlinePaperClip } from 'react-icons/ai';
import { BsFillImageFill, BsFillMicFill } from 'react-icons/bs';
import { RxCross1 } from 'react-icons/rx';
import { RiShareForwardFill } from 'react-icons/ri';
import { AiFillSignal } from 'react-icons/ai';
import { AiOutlinePlus } from 'react-icons/ai';
import { getTime } from '../logic/whatsapplogic';
import { useContext } from 'react';
import '../styles/chatDetails.css';
import filterContext from '../context/filters/filterContext';
import MsgPolls from './MsgPolls';
import { Button, Checkbox, Input, Modal } from 'antd';
import { GrDocumentPdf } from 'react-icons/gr';
import { AiFillDelete } from 'react-icons/ai';
import Loader from './Common/Loader';
import { useSelector } from 'react-redux';

import getSocketInstance from '../pages/socket';
import { debounce } from 'lodash';
import readTick from './read.png';
import notification from 'antd/es/notification';
import { Tooltip } from 'antd';

import PreviewPage from './PreviewPage';
import { IoIosArrowDown } from 'react-icons/io';

function ChatDetail() {
	const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
	const { logoDark } = window.config;
	const {
		getMsg,
		fetchChatConversation,
		SendMessagePoll,
		setgetMsg,
		msgObj,
		selectedMsgs,
		conversationdata,
		selectedConversations,
		setSelectedConversations,
		forwardMessage,
		replyId,
		setReplyId,
		replyMsg,
		setReplyMsg,
		isChatOpen,
		setIsChatOpen,
		namePerson,
		pimgLink,
		togChat,
		settogChat,
		messageTexts,
		setReloadFlag,
		SendMessagewithMedia,
		senderId,
		senderName,
		displayedUsersOfGroup,
		usersOfParticularGroup,
		forwardCheckbox,
		setForwardCheckbox,
		setSelectedMsgs,
		setFlagScroll,
		flagScroll,
		setsender_id,
		sender_id,
		SendMessage,
		ConversationId,
		convId,
		setconvoId,
		uploadMedia,
		sampledataa,
		setsampledataa,
		markAsDelete,
		markAsUnsend,
		selectedReceivedMsgs,
		setSelectedReceivedMsgs,
		setConversationdata,
		readConversationByUSer,
		handleFileChange,
		setPreviewURLs,
		selectedFiles,
		setSelectedFiles,
		handlePdfFileChange,
		fileSelect,
		setfileSelect,
		setselectedFilesPdf,
		isPollMsgSelected,
		setIsPollMsgSelected,
		selectedRedFlagMsgs,
		setSelectedRedFlagMsgs,
		imgSent,
		setimgSent,
		showPopupClip,
		setShowPopupClip,
		imgpdfstatus,
		setImgpdfStatus,
		fetchConversation,
		setSelectedMsgsForForward,
		selectedMsgsForDelete,
		setSelectedMsgsForDelete,
		olderMessages,
		setOlderMessages,
		lastchat,
		setLastchat,
		msgDeleted,
		setMsgDeleted,
		mediaPreview,
	} = useContext(filterContext);

	const [componentMounted, setComponentMounted] = useState(false);
	const [messages, setMessages] = useState(messagesData);
	const [typing, setTyping] = useState(false);
	const inputRef = useRef(null);
	const bottomRef = useRef(null);
	// const [selectedFiles, setSelectedFiles] = useState([]);
	const [forwardModal, setForwardModal] = useState(false);
	const [deleteModal, setDeleteModal] = useState(false);
	const [searchQuery, setSearchQuery] = useState('');
	const [dataaa, setData] = useState({});
	const [selectAll, setSelectAll] = useState(false);
	const [filteredConversations, setFilteredConversations] = useState([]);
	const [inputValue, setInputValue] = useState('');
	const [offset, setOffset] = useState(0);
	const [isLoading, setIsLoading] = useState(false);
	const [initialLoadComplete, setInitialLoadComplete] = useState(false);
	// Add a ref to the chat container
	const chatContainerRef = useRef(null);
	const [count, setCount] = useState(0);
	const [typingText, setTypingText] = useState('');
	let socket;

	//user from redux store
	const userSelector = state => state.user;
	const user = useSelector(userSelector);
	const textboxRef = useRef(null);

	const [receivedConvId, setReceivedConvId] = useState('');
	const [typo, setTypo] = useState(null);

	// console.log(usersOfParticularGroup)
	useEffect(() => {
		if (replyId !== '') {
			// Use the current property of the ref to get the DOM node and set focus
			inputRef.current.focus();
		}
	}, [replyId]);
	
	const handleOutsideClick = (event) => {
		// Check if the click is outside the popup and the button
		if (!event.target.closest(".upload-btn")) {
			setShowPopupClip(false);
		}
	};
	
	useEffect(() => {
		if (showPopupClip) {
			window.addEventListener('click', handleOutsideClick);
	
			return () => {
				window.removeEventListener('click', handleOutsideClick);
			};
		}
	}, [showPopupClip]);
	// useEffect(() => {
	// 	const container = chatContainerRef.current;
	// 	console.log(count);
	// 	if (
	// 		count < 2 &&
	// 		container.scrollTop !== container.scrollHeight &&
	// 		getMsg != null &&
	// 		getMsg.length !== 0
	// 	) {
	// 		chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
	// 		setInitialLoadComplete(true);
	// 		setCount(prevCount => prevCount + 1);
	// 	}
	// }, [getMsg, initialLoadComplete]);
	useEffect(() => {
		if (getMsg.length <= 50 && msgDeleted == false) {
			chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
			setInitialLoadComplete(true);
		}
		setTimeout(() => {
			setMsgDeleted(false);
		}, 2000);
	}, [getMsg]);
	// if(imgSent==1){
	// 	chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
	// }
	// console.log("tetsttttttt",convId)
	// useEffect(() => {
	// 	if (lastchat && chatContainerRef.current) {
	// 	  // Scroll to the bottom of the chat container
	// 	  chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
	// 	}
	//   }, [lastchat]);
	const [isScrollingUp, setIsScrollingUp] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			const chatContainer = chatContainerRef.current;
			const bottomElement = bottomRef.current;

			if (!chatContainer || !bottomElement) return;

			const containerHeight = chatContainer.clientHeight;
			const scrollHeight = chatContainer.scrollHeight;
			const scrollTop = chatContainer.scrollTop;

			if (scrollTop < scrollHeight - containerHeight - 20) {
				setIsScrollingUp(true);
			} else {
				setIsScrollingUp(false);
			}
		};

		const chatContainer = chatContainerRef.current;
		if (chatContainer) {
			chatContainer.addEventListener('scroll', handleScroll);
		}

		return () => {
			if (chatContainer) {
				chatContainer.removeEventListener('scroll', handleScroll);
			}
		};
	}, []);

	useEffect(() => {
		socket = getSocketInstance(user);
		console.log(socket);

		socket.on('user_typing_status', data => {
			setTypo(data);
		});

		socket.emit('user_online', {
			userId: user._id,
			token: `Token ${window.localStorage.getItem('token')}`,
		});

		socket.on('receive_message', data => {
			console.log('hit');
			// console.log(data);
			// console.log(convId);
			setData(data.msg);
			setReceivedConvId(data.msg.conversation);
			// console.log(convId)
			setConversationdata(prevData => {
				const conversationIndex = prevData.findIndex(
					conversation => conversation._id === data.msg.conversation
				);

				if (conversationIndex !== -1) {
					const updatedConversation = {
						...prevData[conversationIndex],
					};
					const newData = prevData.filter(
						(conversation, index) => index !== conversationIndex
					);
					return [updatedConversation, ...newData];
				}

				return prevData;
			});
			console.log(data.msg, user._id);
			// socket.emit('delivered_message', {
			// 	messageId: data.msg,
			// 	recipientUserId: user._id,
			// 	token: `Token ${window.localStorage.getItem('token')}`,
			// });

			// socket.on('delivery_status_updated', data => {
			// 	if (data && data.deliveredStatus != undefined) {
			// 		// console.log(data);
			// 		// Check if all the statuses are "delivered"
			// 		const isAllDelivered = data.deliveryStatus.every(
			// 			status => status.status === 'delivered'
			// 		);

			// 		if (isAllDelivered) {
			// 			// Find the div with data._id
			// 			const messageDiv = document.getElementById(data._id);

			// 			if (messageDiv) {
			// 				// Find the <img> tag inside the div with id "tickmark"
			// 				const tickMarkImg = messageDiv.querySelector('.tickmark');

			// 				if (tickMarkImg) {
			// 					// Update the content of the <p> tag with the "double tick" icon
			// 					tickMarkImg.innerHTML = '<BsCheckAll />';
			// 				}
			// 			}
			// 		}
			// 	}
			// });
		});

		// socket.on('delivery_status_updated', data => {
		// 	// Check if all the statuses are "delivered"
		// 	// console.log(data);
		// 	if (data) {
		// 		const isAllDelivered = data.msg.deliveredStatus.every(
		// 			status => status.status === 'delivered'
		// 		);

		// 		if (isAllDelivered) {
		// 			// Find the div with data._id
		// 			const messageDiv = document.getElementById(data.msg._id);

		// 			if (messageDiv) {
		// 				// Find the <p> tag inside the div with id "tickmark"
		// 				const tickMarkPara = messageDiv.querySelector('.tickimg');

		// 				if (tickMarkPara) {
		// 					// Update the content of the <p> tag with the "double tick" icon
		// 					tickMarkPara.src = readTick;
		// 				}
		// 			}
		// 		}
		// 	}
		// });
		// Clean up the socket connection on component unmount
		return () => {
			if (socket) {
				socket.disconnect();
			}
		};
	}, []);

	useEffect(() => {
		if (convId === receivedConvId) {
			// console.log("Condition checking",convId);
			if (convId) {
				const updatedData = { ...dataaa, readBy: [...dataaa.readBy, user._id] };
				setgetMsg(prevMsg => [updatedData, ...(prevMsg || [])]);
				// console.log('===============', getMsg);
				setTimeout(() => {
					chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
				}, 500);
				setData(prevData => ({ ...prevData, readBy: updatedData.readBy }));
				readConversationByUSer(convId);
			}
		} else {
			// Check if receivedConvId matches any conversation in conversationsdata
			// const matchingConversationIndex = conversationdata.findIndex(conv => conv._id === receivedConvId);
			// console.log("Index = ", matchingConversationIndex);

			// if (matchingConversationIndex !== -1) {
			// 	setConversationdata(prevConversations => {
			// 		const updatedConversations = [...prevConversations];
			// 		updatedConversations[matchingConversationIndex] = {
			// 			...updatedConversations[matchingConversationIndex],
			// 			messageCount: updatedConversations[matchingConversationIndex].messageCount + 1
			// 		};
			// 		console.log(updatedConversations[matchingConversationIndex])
			// 		return updatedConversations;
			// 	});
			// }
			fetchConversation();
		}
		setReceivedConvId('');
	}, [receivedConvId]);

	useEffect(() => {
		if (typo != null) {
			// console.log("Aceept" , convId)
			if (convId === typo.convId) {
				// console.log(typo)
				// console.log("checking",convId);
				setTypingText(typo.user);

				setTimeout(() => {
					setTypingText('');
				}, 1000);
			}
		}
		// setTypingText("");
		setTypo(null);
	}, [typo]);

	// Cleanup effect to reset the count after the component unmounts
	useEffect(() => {
		console.log(convId);
		return () => {
			setCount(0);
		};
	}, [convId]);

	const [inputFields, setInputFields] = useState([{ value: '' }, { value: '' }]);
	const [question, setQuestion] = useState('');
	const [options, setOptions] = useState(['', '']);
	useEffect(() => {
		fetchChatConversation(convId);
	}, [togChat]);

	function polsSubmission(event) {
		event.preventDefault();
		const form = event.target;
		const question = form.question.value.trim(); // Trim to remove leading and trailing spaces

		if (!question) {
			setpolsModal(!polsModal);
			notification.error({
				message: 'There must be a question for a poll',
			});
			return;
		}

		const options = [];
		const seenOptions = new Set(); // Use a Set to track unique options

		for (let i = 0; i < form.elements.length; i++) {
			const element = form.elements[i];

			if (element.name.startsWith('option')) {
				const optionValue = element.value.trim(); // Trim to remove leading and trailing spaces

				if (!optionValue) {
					notification.info({ message: 'Option cannot be empty' });
					return;
				}

				if (seenOptions.has(optionValue)) {
					notification.info({ message: "Options can't be the same" });
					return;
				}

				options.push(optionValue);
				seenOptions.add(optionValue);
			}
		}

		// Options should have at least two elements
		if (options.length < 2) {
			notification.error({
				message: 'There must be at least two options for a poll',
			});
			return;
		}

		// Handle your SendMessagePoll logic with question and options
		SendMessagePoll(convId, question, options);

		// Close the modal and reset the state
		setpolsModal(!polsModal);
		setQuestion('');
		setOptions(['', '']);
	}

	const handleAddField = () => {
		if (options.length < 6) {
			setOptions([...options, '']);
		} else {
			notification.info({ message: 'You can add only 6 options' });
		}
	};
	let previousId = '';
	let previousTime = '';
	const [polsModal, setpolsModal] = useState(false);
	const handlePolsModal = () => {
		console.log(inputFields);
		setpolsModal(!polsModal);
		if (!polsModal) {
			setQuestion('');
			setOptions(['', '']);
		}
	};
	// useEffect(() => {
	// 	// console.log('Selected Files:', selectedFiles);
	// }, [selectedFiles]);
	const handletoggle = event => {
		settogChat(current => !current);
		mediaPreview();
	};

	const [previousCount, setPreviousCount] = useState(0);
	// const [showPopupClip, setShowPopupClip] = useState(false);

	const handleTypingStatusDebounced = debounce(() => {
		// Emit the "user_typing" event to the server with the list of active user IDs except the current user
		// console.log(senderId, senderName);
		const usersTyping = usersOfParticularGroup
			.map(user => user._id)
			.filter(userId => userId !== senderId);

		socket = getSocketInstance(user);
		socket.emit('user_typing', {
			active: usersTyping,
			sender: senderName,
			senderId,
			convId,
		});
		// console.log('emited');
	}, 500);

	const handleInputChange = event => {
		inputRef.current.value.length === 0 ? setTyping(false) : setTyping(true);

		const trimmedInputValue = inputRef.current.value.trim();
		const currentCount = (trimmedInputValue.match(/@/g) || []).length;

		handleTypingStatusDebounced.cancel();

		if (inputRef.current.value.length > 0) {
			handleTypingStatusDebounced();
		}

		if (previousCount > currentCount) {
			const existingDropdown = document.querySelector('.dropdown-container');
			if (existingDropdown) {
				existingDropdown.remove();
			}
		}
		setPreviousCount(currentCount);
	};
	const handleKeyDown = event => {
		if (event.key === 'Enter' && event.shiftKey) {
			event.preventDefault();
			inputRef.current.value += '\n';
		} else if (event.key === '@') {
			// event.preventDefault();
			// console.log('Called');
			showDropdownList(filterUsers(inputRef.current.value));
			// inputRef.current.value += '@';
		} else if (event.key === 'Enter' && !event.shiftKey) {
			event.preventDefault();
			handleInputSubmit();
		}
	};

	const filterUsers = username => {
		// console.log(usersOfParticularGroup);
		return usersOfParticularGroup.filter(user =>
			user.user.username.startsWith('')
		);
	};

	const showDropdownList = filteredUsers => {
		const existingDropdown = document.querySelector('.dropdown-container');
		if (existingDropdown) {
			existingDropdown.remove();
		}

		const dropdownContainer = document.createElement('div');
		dropdownContainer.classList.add('dropdown-container');

		const dropdownList = document.createElement('ul');
		dropdownList.classList.add('dropdown-list');

		filteredUsers.forEach(user => {
			const listItem = document.createElement('li');
			listItem.textContent = user.user.username;

			listItem.addEventListener('click', event => {
				const username = event.target.textContent;
				inputRef.current.value += username;
				dropdownContainer.remove();
			});

			dropdownList.appendChild(listItem);
		});

		dropdownContainer.appendChild(dropdownList);

		const textareaParent = document.querySelector('#textarea').parentElement;
		textareaParent.insertBefore(dropdownContainer, textareaParent.firstChild);
	};

	const handleInputSubmit = () => {
		if (inputRef.current.value.length > 0) {
			const inputValue = inputRef.current.value.trim();
			const regex = /^[\n\s]*$/;

			if (inputValue.length > 0 && !regex.test(inputValue)) {
				const words = inputValue.split(' ');
				const mentionedUserIds = [];

				words.forEach(word => {
					if (word.startsWith('@')) {
						const username = word.substring(1);
						const mentionedUser = usersOfParticularGroup.find(
							user => user.user.username === username
						);
						if (mentionedUser) {
							mentionedUserIds.push(mentionedUser.user._id);
						}
					}
				});

				if (replyId) {
					SendMessage(inputValue, convId, mentionedUserIds, replyId);

					// setReplyMessage(''); // Clear the reply message text after sending
					setReplyId(null); // Clear the replyId after sending
					setReplyMsg(null);
					setTimeout(() => {
						chatContainerRef.current.scrollTop =
							chatContainerRef.current.scrollHeight;
					}, 500);
				} else {
					SendMessage(inputValue, convId, mentionedUserIds);
					// console.log(chatContainerRef.current.scrollHeight);
				}
				inputRef.current.value = '';
				inputRef.current.focus();
				setTyping(false);
			}
		}
	};

	const handleCancel = () => {
		setForwardModal(false);
		setSelectedConversations([]);
		setSearchQuery('');
		setDeleteModal(false);
	};
	const handleOk = () => {
		setForwardModal(false);
		setForwardCheckbox(false);
		setSearchQuery('');
		forwardMessage();
	};
	const handleDeleteForMe = () => {
		setForwardCheckbox(false);
		setDeleteModal(false);
		markAsDelete(convId);
	};
	const handleDeleteForEveryone = () => {
		setForwardCheckbox(false);
		setDeleteModal(false);
		markAsUnsend(convId);
	};
	const handleSearch = e => {
		setSearchQuery(e.target.value);
	};
	const handleSelectAll = () => {
		if (selectAll) {
			setSelectedConversations([]);
		} else {
			const allConvIds = filteredConversations.map(chat => chat._id);
			setSelectedConversations(allConvIds);
		}
		setSelectAll(!selectAll);
	};

	const handleUserSelect = userId => {
		if (selectedConversations.includes(userId)) {
			setSelectedConversations(selectedConversations.filter(id => id !== userId));
		} else {
			setSelectedConversations([...selectedConversations, userId]);
		}
	};
	const handleScrollToBottom = () => {
		chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
	};
	useEffect(() => {
		const debounceSearch = setTimeout(() => {
			const lowerCaseQuery = searchQuery.toLowerCase();
			if (conversationdata) {
				const filteredConversations = conversationdata.filter(chat =>
					chat.name.toLowerCase().includes(lowerCaseQuery)
				);
				setFilteredConversations(filteredConversations);
			}
		}, 300);
		return () => {
			clearTimeout(debounceSearch);
		};
	}, [searchQuery, conversationdata]);

	useEffect(() => {
		const listener = e => {
			if (e.code === 'Enter' && !e.shiftKey) handleInputSubmit();
		};

		document.addEventListener('keydown', listener);
		return () => document.removeEventListener('keydown', listener);
	});

	const togglePopup = () => {
		setShowPopupClip(!showPopupClip);
	};
	const imgtog = () => {
		setSelectedFiles([]);

		// console.log(selectedFiles);
		document.querySelector('.upload-btn .imageFile').click();
	};
	const doctog = () => {
		setselectedFilesPdf([]);

		document.querySelector('.upload-btn .pdfFile').click();
	};
	const fetchMoreMessages = async () => {
		try {
			console.log(isLoading);
			setIsLoading(true);
			const newOffset = getMsg.length; // Start fetching from the current number of messages
			const remainingMessages = Math.max(0, sampledataa.count - newOffset); // Calculate remaining messages to read
			const newLimit = Math.min(50, remainingMessages);
			// console.log('remainingMessages', remainingMessages);
			// console.log('newLimit', newLimit);
			const response = await fetch(
				`${apiBaseUrl}/chats/conversation/get?id=${convId}&skip=${newOffset}&limit=${newLimit}`,
				{
					method: 'GET',
					headers: {
						'Content-Type': 'application/json',
						authorization: `Token ${window.localStorage.getItem('token')}`,
					},
				}
			);
			const data = await response.json();
			console.log('data', data.messages);
			if (data && data.messages && data.messages.length > 0) {
				// Concatenate new messages to the existing messages
				const prevScrollHeight = chatContainerRef.current.scrollHeight;
				console.log(prevScrollHeight);
				setgetMsg(prevMessages => [...prevMessages, ...data.messages]);
				console.log(chatContainerRef.current.scrollTop);
				chatContainerRef.current.scrollTop =
					chatContainerRef.current.scrollHeight - prevScrollHeight;
				setOlderMessages(true);
			} else {
				setOlderMessages(false);
			}
			setIsLoading(false);
		} catch (error) {
			console.log('Error fetching more messages:', error);
			setIsLoading(false);
		}
	};
	function isValidUrl(str) {
		try {
			new URL(str);
			return true;
		} catch (error) {
			var urlPattern = new RegExp(
				'^(https?:\\/\\/)?' + // validate protocol
				'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // validate domain name
				'((\\d{1,3}\\.){3}\\d{1,3}))' + // validate OR ip (v4) address
				'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // validate port and path
				'(\\?[;&a-z\\d%_.~+=-]*)?' + // validate query string
					'(\\#[-a-z\\d_]*)?$',
				'i'
			); // validate fragment locator
			return urlPattern.test(str);
		}
	}

	return (
		<div className="chatDetails-container">
			<div className="contact-navbar" onClick={handletoggle}>
				<div className="contact-info">
					<img className="profile-pic" src={pimgLink} alt="profile_picture" />
					<div className="contact-details">
						<h6 className="contact-name">{namePerson}</h6>
						<p className="contact-status">
							{typingText == '' ? 'Click here to view information' : typingText}
						</p>
					</div>
				</div>

				{/* Buttons */}
				{/* <div className="search-options-btns">
						<RoundedBtn icon={<MdSearch />} />
						<RoundedBtn icon={<HiDotsVertical />} />
						</div> */}
			</div>
			{isLoading && (
				<div
					style={{
						backgroundColor: 'transparent',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
					}}
				>
					{' '}
					<Loader />
				</div>
			)}
			{/* Messages section */}
			<div className="msgs-section" ref={chatContainerRef}>
				{olderMessages ? (
					<div className="msg-date-info1" onClick={fetchMoreMessages}>
						Sync older messages , Click Here.
					</div>
				) : (
					<div className="msg-date-info1">No More Messages to Fetch.</div>
				)}

				{getMsg &&
					[...getMsg].reverse().map((message, index) => {
						if (index > 0) {
							previousId = getMsg[getMsg.length - index].sender._id;
							previousTime = getMsg[getMsg.length - index].createdAt;
						}
						if (message.poll != undefined && message.poll.question != undefined) {
							return (
								<MsgPolls
									key={index}
									que={message.poll.question}
									opt={message.poll.options}
									msgId={message._id}
									votes={message.poll.votes}
									prevId={previousId}
									prevTime={previousTime}
									sender={message.sender._id == senderId ? true : false}
									senderId={message.sender._id}
									senderName={message.sender.name}
									deliveryStatus={message.deliveredStatus}
									readBy={message.readBy}
									create={message.createdAt}
								/>
							);
						} else if (message.isReplied !== undefined && message.isReplied) {
							// Store replied message in state

							return (
								<div key={index}>
									{/* {handleRenderRepliedMessage(message)} */}

									<Message
										key={index}
										msg={message.text}
										isLink={isValidUrl(message.text) ? true : false}
										media={message.media}
										msgId={message._id}
										isRedFlag={message.isRedFlag}
										remark={message.remark}
										sender={message.sender._id == senderId ? true : false}
										senderId={message.sender._id}
										senderName={message.sender.name}
										prevId={previousId}
										prevTime={previousTime}
										refMsg={message.refReplyId}
										deliveryStatus={message.deliveredStatus}
										readBy={message.readBy}
										create={message.createdAt}
									/>
								</div>
							);
						} else if (message.isForwarded) {
							if (
								message.refForwardId.media == undefined ||
								message.refForwardId.media == null ||
								message.refForwardId.media.length == 0
							) {
								return (
									<Message
										key={index}
										msg={message.refForwardId.text}
										isLink={isValidUrl(message.text) ? true : false}
										msgId={message._id}
										forwardedMsgId={message.refForwardId._id}
										isRedFlag={message.refForwardId.isRedFlag}
										remark={message.remark}
										sender={message.sender._id == senderId ? true : false}
										senderId={message.sender._id}
										senderName={message.sender.name}
										prevId={previousId}
										prevTime={previousTime}
										mentions={message.mentionedUsers}
										isForwarded={message.isForwarded}
										forwardedTag={
											message.refForwardId.sender._id != message.sender._id ? true : false
										}
										deliveryStatus={message.refForwardId.deliveredStatus}
										readBy={message.refForwardId.readBy}
										create={message.createdAt}
									/>
								);
							} else {
								return (
									<Message
										key={index}
										msg={message.refForwardId.text}
										isLink={isValidUrl(message.text) ? true : false}
										media={message.refForwardId.media}
										msgId={message._id}
										forwardedMsgId={message.refForwardId._id}
										isRedFlag={message.refForwardId.isRedFlag}
										remark={message.remark}
										sender={message.sender._id == senderId ? true : false}
										senderId={message.sender._id}
										senderName={message.sender.name}
										prevId={previousId}
										prevTime={previousTime}
										isForwarded={message.isForwarded}
										forwardedTag={
											message.refForwardId.sender._id != message.sender._id ? true : false
										}
										deliveryStatus={message.refForwardId.deliveredStatus}
										readBy={message.refForwardId.readBy}
										create={message.createdAt}
									/>
								);
							}
						} else {
							if (
								message.media == undefined ||
								message.media == null ||
								message.media.length == 0
							) {
								return (
									<Message
										key={index}
										msg={message.text}
										isLink={isValidUrl(message.text) ? true : false}
										msgId={message._id}
										isRedFlag={message.isRedFlag}
										remark={message.remark}
										sender={message.sender._id == senderId ? true : false}
										senderId={message.sender._id}
										senderName={message.sender.name}
										prevId={previousId}
										prevTime={previousTime}
										isForwarded={message.isForwarded}
										mentions={message.mentionedUsers}
										isPdf={false}
										deliveryStatus={message.deliveredStatus}
										readBy={message.readBy}
										create={message.createdAt}
									/>
								);
							} else {
								return (
									<Message
										key={index}
										msg={message.text}
										isLink={isValidUrl(message.text) ? true : false}
										media={message.media}
										msgId={message._id}
										isRedFlag={message.isRedFlag}
										remark={message.remark}
										sender={message.sender._id == senderId ? true : false}
										senderId={message.sender._id}
										senderName={message.sender.name}
										prevId={previousId}
										prevTime={previousTime}
										isForwarded={message.isForwarded}
										isPdf={false}
										deliveryStatus={message.deliveredStatus}
										readBy={message.readBy}
										create={message.createdAt}
									/>
								);
							}
						}
					})}
			</div>
			{isScrollingUp && (
				<div
					className={`scroll-to-bottom-button ${
						isScrollingUp ? 'visible' : 'hidden'
					}`}
					onClick={handleScrollToBottom}
				>
					<span
						style={{
							backgroundColor: '#202C33',
							height: '40px',
							width: '40px',
							borderRadius: '50%',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
						}}
					>
						<IoIosArrowDown size={25} color="#626C71" />
					</span>
				</div>
			)}
			<div ref={bottomRef} />

			{replyId && (
				<div className="replied-message">
					<span
						className="cross-button"
						onClick={() => {
							setReplyMsg(null);
							setReplyId(null);
						}}
					>
						&#x2715;
					</span>
					<p style={{ fontSize: '15px', color: 'rgb(115, 129, 255)' }}>
						{replyMsg.name}
					</p>
					<p style={{ fontSize: 'small' }}>{replyMsg.text}</p>
				</div>
			)}

			{/* Bottom section */}

			{forwardCheckbox ? (
				<div className="bottom-section">
					{/* Cancel btn */}
					<RoundedBtn
						icon={<RxCross1 />}
						onClick={() => {
							setForwardCheckbox(false);
							// setSelectedMsgs([]);
							setSelectedMsgsForForward([]);
							setSelectedMsgsForDelete([]);
							setSelectedReceivedMsgs([]);
							setIsPollMsgSelected([]);
							setSelectedRedFlagMsgs([]);
						}}
					/>

					<span className="upload-btn" style={{ color: 'white' }}>
						{selectedMsgsForDelete.length} selected
					</span>

					{/* Forward btn */}
					{selectedMsgsForDelete.length > 0 && (
						<span className="mic-send-btn">
							{isPollMsgSelected.length === 0 &&
								!getMsg
									.map(m => {
										return m.text == '🚫 This message was deleted.' &&
											selectedMsgsForDelete.includes(m._id)
											? true
											: false;
									})
									.includes(true) && (
									<RoundedBtn
										icon={<RiShareForwardFill />}
										tooltip="Forward"
										onClick={() => {
											setForwardModal(true);
										}}
									/>
								)}
							<RoundedBtn
								icon={<AiFillDelete />}
								tooltip="Delete"
								onClick={() => {
									setDeleteModal(true);
									// console.log(selectedRedFlagMsgs.length);
								}}
							/>
						</span>
					)}
				</div>
			) : (
				<div className="bottom-section">
					{/* <RoundedBtn icon={<BiHappy />} onClick={handleEmojiClick} /> */}
					<div className="upload-btn">
						<input
							type="file"
							multiple
							style={{ display: 'none' }}
							className="imageFile"
							onChange={handleFileChange}
						/>
						<input
							type="file"
							multiple
							style={{ display: 'none' }}
							className="pdfFile"
							onChange={handlePdfFileChange}
						/>
						<button
							// onClick={() =>
							//   document.querySelector(".upload-btn input[type=file]").click()
							// }
							onClick={togglePopup}
							style={{
								backgroundColor: '#202D33',
								border: 'none',
								color: '#8796a1',
								width: '30%',
							}}
							className={`popup ${showPopupClip ? 'show' : ''}`}
						>
							<div className={`popuptext ${showPopupClip ? 'show' : ''}`}>
								<div style={{ margin: '5px' }}>
									<Tooltip title="Documents" placement="right">
										<Button className="ant-d-button" onClick={doctog}>
											<GrDocumentPdf />
										</Button>
									</Tooltip>
								</div>
								<div style={{ margin: '5px' }}>
									<Tooltip title="Images" placement="right">
										<Button
											className="ant-d-button"
											// onClick={() =>
											// 	document.querySelector('.upload-btn .imageFile').click()
											// }
											onClick={imgtog}
										>
											<BsFillImageFill style={{ color: 'black' }} />
										</Button>
									</Tooltip>
								</div>
							</div>
							<RoundedBtn icon={<AiOutlinePaperClip />} tooltip="Documents" />
						</button>
					</div>
					{/* <div className="popup" onClick={togglePopup}>
								Hover over me to see the popup
									<div className={`popuptext ${showPopupClip ? "show" : ""}`}>
										A Simple pop up
									</div>
								</div> */}
					<span className="mr-2">
						<RoundedBtn
							icon={<AiFillSignal />}
							tooltip="Create Poll"
							onClick={handlePolsModal}
						/>
					</span>
					<Modal
						title={
							<span style={{ fontWeight: 'bold', fontSize: '20px' }}>Create Poll</span>
						}
						open={polsModal}
						onCancel={handlePolsModal}
						width="450px"
						headerClassName="custom-modal-header"
						className="poll-modal"
						footer={null}
						style={{
							backgroundColor: 'black',
							color: 'white',
							borderRadius: '8px',
							border: '2px solid rgb(48, 48, 48)',
						}}
					>
						<form onSubmit={polsSubmission}>
							<div style={{ height: '400px', overflow: 'auto' }}>
								<label htmlFor="question" className="polsLabels">
									<b>Question</b>
								</label>{' '}
								<br />
								<input
									className="polsfields"
									type="text"
									id="question"
									name="question"
									placeholder="Ask question"
									autocomplete="off"
									value={question}
									onChange={e => setQuestion(e.target.value)}
								/>
								<br />
								<label htmlFor="options" className="polsLabels">
									<b>Options</b>
								</label>
								{options.map((option, index) => (
									<input
										key={index}
										type="text"
										className="polsfields"
										placeholder="Add"
										autocomplete="off"
										name={`option${index + 1}`}
										value={option}
										onChange={e => {
											const newOptions = [...options];
											newOptions[index] = e.target.value;
											setOptions(newOptions);
										}}
									/>
								))}
								<div
									style={{ paddingTop: '15px', cursor: 'pointer' }}
									onClick={handleAddField}
								>
									<AiOutlinePlus style={{ fontSize: '20px' }} />{' '}
									<b>
										<span>Add Option</span>
									</b>
								</div>
							</div>
							<div style={{ textAlign: 'right', marginTop: '20px' }}>
								<button
									type="submit"
									className="btn"
									style={{
										fontSize: '20px',
										borderRadius: '50%',
										backgroundColor: '#202D33',
									}}
								>
									<MdSend style={{ color: 'white' }} />
								</button>
							</div>
						</form>
					</Modal>

					<textarea
						className="input-bar"
						id="textarea"
						type="text"
						placeholder="Type a message"
						onChange={handleInputChange}
						ref={inputRef}
						onKeyDown={handleKeyDown}
					/>

					<span className="mic-send-btn">
						<RoundedBtn icon={<MdSend />} onClick={handleInputSubmit} />
					</span>
				</div>
			)}

			<Modal
				title="Select Conversations"
				visible={forwardModal}
				onCancel={handleCancel}
				footer={null}
				bodyStyle={{
					maxHeight: '550px',
					overflow: 'auto',
					paddingTop: '0',
					paddingBottom: '0',
				}}
			>
				<div className="edit-shortcut-modal">
					<div className="broadcast-modal">
						<div>
							<Input
								className="chat-details-input-override"
								type="text"
								value={searchQuery}
								onChange={handleSearch}
								placeholder="Search Conversations"
							/>
						</div>

						<div className="broadcast-input-bar">
							<input
								type="checkbox"
								checked={selectAll}
								onChange={handleSelectAll}
								className="modal-checkbox"
							/>
							<h6 className="contact-name">Select All</h6>
						</div>
					</div>

					{filteredConversations.map((chat, i) => {
						if (chat.isGroup) {
							return (
								<div key={chat._id} className="modal-conversations">
									<Checkbox
										checked={selectedConversations.includes(chat._id)}
										onChange={() => handleUserSelect(chat._id)}
										className="rounded-checkbox"
									/>
									<img
										className="profile-pic"
										src={!chat.dp ? window.config.favicon : chat.dp}
										alt="profile pic"
									/>
									<h6 className="contact-name">{chat.name}</h6>
								</div>
							);
						}
						return null;
					})}
				</div>
				<div className="modal-btn">
					<Button onClick={handleCancel} className="modal-checkbox">
						Cancel
					</Button>
					<Button
						type="primary"
						onClick={handleOk}
						disabled={selectedConversations.length === 0}
					>
						Forward
					</Button>
				</div>
			</Modal>

			<Modal
				visible={deleteModal}
				onCancel={handleCancel}
				footer={null}
				closable={false}
				maskClosable={false}
				centered
				bodyStyle={{ padding: 20, textAlign: 'center' }}
			>
				{selectedRedFlagMsgs.length === 0 ? (
					selectedMsgsForDelete.length > 1 ? (
						<h4 style={{ marginBottom: 20 }}>Delete Messages?</h4>
					) : (
						<h4 style={{ marginBottom: 20 }}>Delete Message?</h4>
					)
				) : (
					<h4 style={{ marginBottom: 20 }}>Red Flag Message Selected</h4>
				)}

				{selectedRedFlagMsgs.length > 0 ? (
					<div>
						<p>
							You have selected one or more red flag messages, kindly resolve it and
							try again.
						</p>
						<Button onClick={handleCancel}>Ok</Button>
					</div>
				) : (
					<div>
						<Button style={{ marginRight: 10 }} onClick={handleDeleteForMe}>
							Delete For Me
						</Button>
						{selectedReceivedMsgs.length == 0 && (
							<Button
								style={{ marginRight: 10 }}
								type="primary"
								danger
								onClick={handleDeleteForEveryone}
							>
								Delete For Everyone
							</Button>
						)}
						<Button onClick={handleCancel}>Cancel</Button>
					</div>
				)}
			</Modal>
			{/* <div style={{display:"none"}}>
			<PreviewPage passedref={chatContainerRef}/>
		</div> */}
		</div>
	);
}

export default ChatDetail;
